import React from 'react';
import { Typography, Box } from '@mui/material';

const KYCcard = ({ icon, content }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        my: 3,
        px: 2,
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <img src={icon} alt="img" />
      <Typography
        variant="p"
        sx={{
          color: '#1D1E24',
          fontWeight: '500',
          width: '70%',
        }}
      >
        {content}
      </Typography>
    </Box>
  );
};

export default KYCcard;
